module.exports = __webpack_public_path__ + "img/lepao-icon.7c560951.png";